import React from 'react';

export default () => (
  <svg height="100px" width="100px" version="1.1" viewBox="0 0 64 64">
    <g>
      <g fill="#1D1D1B">
        <path
          d="m17.181,58.816c0.101,0.015 0.188,0.059 0.293,0.059h33.286c0.046,0 0.084-0.023 0.129-0.026 0.044,0.003 0.081,0.026 0.128,0.026 7.165,0 12.996-6.027 12.996-13.435 0-7.309-5.944-13.255-13.253-13.255-0.021,0-0.036,0.011-0.057,0.011-1.643-4.602-6.034-7.91-11.193-7.91-1.137,0-2.056,0.919-2.056,2.054 0,1.134 0.919,2.054 2.056,2.054 4.294,0 7.787,3.494 7.787,7.789 0,1.135 0.919,2.055 2.053,2.055 1.077,0 1.93-0.833 2.021-1.882 4.753,0.321 8.532,4.251 8.532,9.084 0,5.143-3.985,9.326-8.887,9.326-0.047,0-0.084,0.023-0.128,0.026-0.045-0.003-0.083-0.026-0.129-0.026h-32.41c-7.853,0-14.24-6.387-14.24-14.239s6.388-14.241 14.24-14.241c1.354,0 2.691,0.189 3.981,0.563 1.09,0.314 2.229-0.312 2.544-1.4 0.316-1.089-0.309-2.229-1.401-2.545-1.658-0.482-3.384-0.726-5.124-0.726-10.119-3.55271e-15-18.349,8.231-18.349,18.349 0,9.723 7.607,17.682 17.181,18.289z"
          fill="#006DF0"
        />
        <path
          d="M32.006,45.879c1.136,0,2.054-0.919,2.054-2.054V11.888l5.227,5.227c0.401,0.401,0.928,0.602,1.453,0.602    c0.524,0,1.051-0.201,1.452-0.602c0.802-0.803,0.802-2.103,0-2.905L33.33,5.348c-0.803-0.802-2.104-0.802-2.905,0l-8.86,8.861    c-0.803,0.802-0.803,2.103,0,2.905c0.4,0.401,0.927,0.602,1.452,0.602s1.051-0.201,1.452-0.602l5.483-5.484v32.194    C29.952,44.959,30.87,45.879,32.006,45.879z"
          fill="#006DF0"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/upload.js